import { createBrowserRouter, Navigate } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import ChunkErrorFallback from 'components/ChunkErrorFallback';
import Loadable from 'components/Loadable';

const DinnerPublic = Loadable(() => import('pages/clubastra/dinnerPublic'));
const GuestlistSubmitPublic = Loadable(() => import('pages/public/guestlistSubmitPublic'));
const SpecialEventSubmitPublic = Loadable(() => import('pages/public/specialEventSubmitPublic'));
const HostOnboardingPublic = Loadable(() => import('pages/public/HostOnboardingPublic'));

if (typeof window !== 'undefined') {
  const normalizedPath = window.location.pathname.replace(/\/{2,}/g, '/');
  if (normalizedPath !== window.location.pathname) {
    window.history.replaceState(null, '', `${normalizedPath}${window.location.search}${window.location.hash}`);
  }
}

const router = createBrowserRouter([
  {
    // no path – this is a wrapper route that just provides error handling
    errorElement: <ChunkErrorFallback />,
    children: [
      // 🔁 Redirect any stale /free/* paths to the new /login
      { path: '/free/*', element: <Navigate to="/login" replace /> },

      {
        path: '/dinner-public',
        element: <DinnerPublic />
      },

      {
        path: '/guestlist-submit',
        element: <GuestlistSubmitPublic />
      },

      {
        path: '/special-event-submit',
        element: <SpecialEventSubmitPublic />
      },

      {
        path: '/host-onboarding',
        element: <HostOnboardingPublic />
      },

      // Public auth routes
      ...LoginRoutes,

      // Protected routes
      MainRoutes,

      // Unknown address: go home (login or dashboard) instead of the
      // "could not load this page" screen, which is for real load failures.
      { path: '*', element: <Navigate to="/" replace /> }
    ]
  }
]);

export default router;
